// extracted by mini-css-extract-plugin
export var root = "c6fK";
export var rootContainer = "Fp53";
export var rootLink = "Z5hn";
export var rootLinkIcon = "V4uP";
export var rootMobileOpened = "LlS-";
export var rootSocials = "QxoS";